export const METRIC_EVENTS = [
  'plan_opened',
  'comment_created',
  'feedback_copied',
  'portable_downloaded',
] as const

export type ClientMetricEvent = (typeof METRIC_EVENTS)[number]

/** Record one action as an aggregate counter; no slug, identity, URL, or content. */
export function recordMetric(event: ClientMetricEvent): void {
  if (location.protocol !== 'http:' && location.protocol !== 'https:') return
  const body = JSON.stringify({ event })

  try {
    if (navigator.sendBeacon?.('/api/event', new Blob([body], { type: 'application/json' }))) {
      return
    }
  } catch {
    // Fall through to fetch when sendBeacon is unavailable or rejected.
  }

  void fetch('/api/event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
    credentials: 'same-origin',
  }).catch(() => {
    // Analytics must never interrupt the review workflow.
  })
}

/**
 * Count one home-page visit and where it came from. `/` is served as a static
 * file (it never reaches the Worker, so it stays up past the Worker request
 * cap), so the page reports its own load. Sends only `document.referrer` —
 * the page that linked here, as that page's referrer policy allows.
 */
export function recordLandingVisit(): void {
  if (location.protocol !== 'http:' && location.protocol !== 'https:') return
  void fetch('/api/visit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ referrer: document.referrer }),
    keepalive: true,
    credentials: 'same-origin',
  }).catch(() => {
    // Analytics must never interrupt the page.
  })
}
